import { Box as CoreBox, StackView } from 'localmed-core';
import React, { Fragment } from 'react';
import { Link } from '../DiComponents';
import Skeleton from '../Skeleton';
import { Box, H4, HeaderWrapper, Image, Span, StyledText } from './headerStyles';

interface Props {
  logo?: string;
  address?: string;
  display?: string;
  phone?: string;
}
export default function DIGenericHeader({ logo, address, display, phone }: Props) {
  return (
    <HeaderWrapper>
      {logo && <Image src={logo} alt="logo" />}
      <Box>
        <H4 color="white">{display}</H4>
        <CoreBox fontSize="sm">
          <StackView spacing={{ _: 'sm', lg: 'sm' }} direction={{ _: 'column', lg: 'row' }}>
            <StyledText>{address}</StyledText>
            {phone && (
              <Fragment>
                <Span display={{ _: 'none', lg: 'inline' }}> | </Span>
                <Link href={`tel:${phone}`} color="lightBlue">
                  {phone}
                </Link>
              </Fragment>
            )}
          </StackView>
        </CoreBox>
      </Box>
    </HeaderWrapper>
  );
}

export function DiHeaderSkeleton() {
  return (
    <HeaderWrapper>
      <Skeleton dark circle height={60} width={60} mr="md" />
      <StackView spacing="sm">
        <Skeleton dark width={200} />
        <Skeleton dark inactive={false} width={300} />
      </StackView>
    </HeaderWrapper>
  );
}
